// @ts-nocheck
import PropTypes from 'prop-types';
import { Box, Typography } from "@mui/material";
import ShowOptionsMenu from "./components/reusableComponents/ShowOptionsMenu";

import { getUniversalDateTimeFormat } from '../../utils/methods/universalDateTimeFormat';

const EventInformation = ({ event, onDuplicateChanged }) => {

  return (
    <>
      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, mb: "12px" }}>
          <Typography variant="h4" sx={{ fontSize: "24px" }}>
            Event Information
          </Typography>
          {onDuplicateChanged && (
            <ShowOptionsMenu
              eventId={event?._id}
              isDuplicate={event?.isDuplicate === true}
              onDuplicateChanged={onDuplicateChanged}
            />
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            border: "1px solid #D175B6",
            padding: "6px 10px",
            borderRadius: "5px",
            marginBottom: "10px",
            color: "#fff",
          }}
        >
          <Typography variant="span" sx={{ fontSize: "16px" }}>
            Event Name: {event?.eventName || "N/A"}
          </Typography>
          <Typography variant="span" sx={{ fontSize: "16px" }}>
            Venue: {event?.venue || "N/A"}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
            border: "1px solid #D175B6",
            padding: "6px 10px",
            borderRadius: "5px",
            marginBottom: "10px",
            color: "#fff",
          }}
        >
          <Typography variant="span" sx={{ fontSize: "16px" }}>
            {`Start: ${event?.eventStart ? getUniversalDateTimeFormat({
              dateTime: event?.eventStart
            }) || event?.eventStart : "N/A"}`}
          </Typography>
          <Typography variant="span" sx={{ fontSize: "16px" }}>
            {`End: ${event?.eventEnd ? getUniversalDateTimeFormat({
              dateTime: event?.eventEnd
            }) || event?.eventEnd : "N/A"}`}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "16px",
            border: "1px solid #D175B6",
            padding: "6px 10px",
            borderRadius: "5px",
            marginBottom: "10px",
            color: "#fff",
          }}
        >
          {`Venue Address: ${event?.venueAddress || "N/A"}`}
        </Typography>
      </Box>
    </>
  );
};

EventInformation.propTypes = {
  event: PropTypes.object,
  onDuplicateChanged: PropTypes.func,
};

export default EventInformation;
